import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumb = ({ customItems = null }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const routeMap = {
    '/main-dashboard': { label: 'Dashboard', icon: 'LayoutDashboard' },
    '/incidents-list': { label: 'Incidents', icon: 'AlertTriangle' },
    '/create-incident': { label: 'Create Incident', icon: 'Plus', parent: '/incidents-list' },
    '/incident-details': { label: 'Incident Details', icon: 'FileText', parent: '/incidents-list' },
    '/account-settings': { label: 'Account Settings', icon: 'User' },
    '/system-settings': { label: 'System Settings', icon: 'Settings' },
    '/reports-analytics': { label: 'Reports & Analytics', icon: 'BarChart3' }
  };

  const generateBreadcrumbs = () => {
    if (customItems) return customItems;

    const currentRoute = routeMap?.[location?.pathname];
    if (!currentRoute) return [];

    const breadcrumbs = [];

    // Add parent if exists
    if (currentRoute?.parent) {
      const parentRoute = routeMap?.[currentRoute?.parent];
      if (parentRoute) {
        breadcrumbs?.push({
          label: parentRoute?.label,
          path: currentRoute?.parent,
          icon: parentRoute?.icon
        });
      }
    }

    // Add current route
    breadcrumbs?.push({
      label: currentRoute?.label,
      path: location?.pathname,
      icon: currentRoute?.icon,
      current: true
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length === 0) return null;

  const handleNavigation = (path) => {
    if (path && path !== location?.pathname) {
      navigate(path);
    }
  };

  const handleBack = () => {
    if (breadcrumbs?.length > 1) {
      const parentBreadcrumb = breadcrumbs?.[breadcrumbs?.length - 2];
      if (parentBreadcrumb?.path) {
        navigate(parentBreadcrumb?.path);
      }
    } else {
      navigate(-1);
    }
  };

  return (
    <nav className="flex items-center space-x-1 text-sm text-muted-foreground mb-6" aria-label="Breadcrumb">
      {/* Mobile Back Button */}
      <button
        onClick={handleBack}
        className="md:hidden flex items-center space-x-2 p-2 -ml-2 rounded-md hover:bg-muted transition-colors duration-200"
        aria-label="Go back"
      >
        <Icon name="ArrowLeft" size={16} />
        <span>Back</span>
      </button>
      {/* Desktop Breadcrumb */}
      <ol className="hidden md:flex items-center space-x-1">
        {breadcrumbs?.map((item, index) => (
          <li key={item?.path || index} className="flex items-center">
            {index > 0 && (
              <Icon name="ChevronRight" size={14} className="mx-2 text-border-active" />
            )}
            
            {item?.current ? (
              <span className="flex items-center space-x-2 text-foreground font-medium">
                <Icon name={item?.icon} size={16} />
                <span>{item?.label}</span>
              </span>
            ) : (
              <button
                onClick={() => handleNavigation(item?.path)}
                className="flex items-center space-x-2 hover:text-foreground transition-colors duration-200 rounded px-2 py-1 hover:bg-muted"
              >
                <Icon name={item?.icon} size={16} />
                <span>{item?.label}</span>
              </button>
            )}
          </li>
        ))}
      </ol>
      {/* Mobile Current Page */}
      <div className="md:hidden flex items-center space-x-2 text-foreground font-medium">
        <Icon name={breadcrumbs?.[breadcrumbs?.length - 1]?.icon} size={16} />
        <span>{breadcrumbs?.[breadcrumbs?.length - 1]?.label}</span>
      </div>
    </nav>
  );
};

export default Breadcrumb;